export const usersReducer = (state = {loading: true, resultuser: null, users: null, user: null, useractivate: null } , action) => {
    switch (action.type) {
        case 'USER_ADD_SUCCESS':
            return {
                ...state,
                loading:false,
                resultuser: action.payload.message,
                useractivate: action.payload.idUser
            }
        case 'USER_EDIT_SUCCESS':
            return {
                ...state,
                loading:false,
                resultuser: action.payload
            }
        case 'USER_ACTIVATEDEACTIVATE_SUCCESS':
            return {
                ...state,
                loading:false,
                resultuser: action.payload.message
            }
        case 'USER_RESET_RESULT':
            return {...state,
                resultuser: null
            }
        case 'USER_LOADING':
            return {
                ...state,
                loading:true
            }
        case 'USER_NOT_LOADING':
            return {
                ...state,
                loading:false
            }
        case 'USER_DELETE_SUCCESS':
            return {
                ...state,
                loading:false,
                resultuser: action.payload
            }
        case 'USER_GET_SUCCESS':
            return {
                ...state,
                loading:false,
                user: action.payload
            }
        default:
            return state
    }
}

